import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

// Fusão Processos/Caderno (MC26): processes está vazia (auditoria
// confirmou) — redireciona para autos_workspaces, que já grava clientEmail
// no fluxo de criação/edição do caderno (CadernoCockpit.jsx).
export async function fetchProcessesByClientEmail(userEmail) {
  const q = query(collection(db, ...FS.autosWorkspaces(appId)), where('clientEmail', '==', userEmail));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function fetchDocumentsByRelatedEmail(userEmail) {
  const q = query(collection(db, ...FS.documents(appId)), where('relatedEmail', '==', userEmail));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
